import React from "react";

export default function useOnChange<E extends EventTarget & { value: unknown }>(
	setFunction: React.Dispatch<React.SetStateAction<E["value"]>>,
) {
	const onChange = React.useCallback(
		(e: React.ChangeEvent<E>) => {
			setFunction(e.target.value);
		},
		[setFunction],
	);
	return onChange;
}
